// extracted by mini-css-extract-plugin
export default {"arrowButton":"ArrowButton_arrowButton__zUuJo","isLeft":"ArrowButton_isLeft__U5hcu","isDisabled":"ArrowButton_isDisabled__ZjUwh"};